import React from "react";

export const DescendingIcon = () => {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.44772 0.44772 0 1 0H19C19.5523 0 20 0.44772 20 1C20 1.55228 19.5523 2 19 2H1C0.44772 2 0 1.55228 0 1ZM0 6C0 5.4477 0.44772 5 1 5H15C15.5523 5 16 5.4477 16 6C16 6.5523 15.5523 7 15 7H1C0.44772 7 0 6.5523 0 6ZM1 10C0.44772 10 0 10.4477 0 11C0 11.5523 0.44772 12 1 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H1Z"
        fill="inherit"
        fillOpacity="0.85"
      />
    </svg>
  );
};
